import axiosInstance from "./baseService.service";

const API_URL = "agendamento/";

const agendamentoService = {
  cadastrar: async (agendamento) => {
    try {
      const response = await axiosInstance.post(API_URL + "cadastrarAgendamento", agendamento);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  alterar: async (agendamento) => {
    try {
      const response = await axiosInstance.post(API_URL + "alterarAgendamento", agendamento);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  alterarSituacao: async (alteracao) => {
    try {
      const response = await axiosInstance.post(API_URL + "alterarSituacaoAgendamento", alteracao);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  pesquisarAgendamentosPeriodo: async (dataInicial, dataFinal) => {
    try {
      const params = new URLSearchParams();

      params.append("dataInicial", dataInicial);
      params.append("dataFinal", dataFinal);

      const response = await axiosInstance.get(`${API_URL}pesquisarAgendamentosPeriodo?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  pesquisarAgendamentos: async (filtro) => {
    try {
      const params = new URLSearchParams();

      params.append("first", filtro.first);
      params.append("rows", filtro.rows);
      params.append("sortField", filtro.sortField);
      params.append("sortOrder", filtro.sortOrder);

      if (filtro.pacienteId) params.append("pacienteId", filtro.pacienteId);
      if (filtro.pacienteNome) params.append("pacienteNome", filtro.pacienteNome);
      if (filtro.profissionalId) params.append("profissionalId", filtro.profissionalId);
      if (filtro.profissionalNome) params.append("profissionalNome", filtro.profissionalNome);
      if (filtro.salaId) params.append("salaId", filtro.salaId);
      if (filtro.situacaoAgendamentoId) params.append("situacaoAgendamentoId", filtro.situacaoAgendamentoId);
      if (filtro.dataInicial) params.append("dataInicial", filtro.dataInicial);
      if (filtro.dataFinal) params.append("dataFinal", filtro.dataFinal);
      if (filtro.presencial !== null && filtro.presencial !== undefined) params.append("presencial", filtro.presencial);

      const response = await axiosInstance.get(`${API_URL}pesquisarAgendamentos?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  pesquisarAgendamentosPerfil: async (dataInicial, dataFinal) => {
    try {
      const params = new URLSearchParams();

      params.append("dataInicial", dataInicial);
      params.append("dataFinal", dataFinal);

      const response = await axiosInstance.get(`${API_URL}pesquisarAgendamentosPerfil?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  excluir: async (id) => {
    try {
      const params = new URLSearchParams();
      params.append("id", id);
      const response = await axiosInstance.post(`${API_URL}excluirAgendamento?${params.toString()}`, {});
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default agendamentoService;
